<template>
  <div class="pt-4">
    <ProfileSecurity />
  </div>
</template>

<script lang="ts" setup>
import ProfileSecurity from '@/components/deepadmin/profile/ProfileSecurity.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.personal.my_account.security',
  },
})
</script>
